// import React, { useState } from "react";
// import styled from "styled-components";
// import { FaMoneyBill, FaRegCalendarAlt, FaShoppingCart } from "react-icons/fa";
// import { MdAccountBalanceWallet } from "react-icons/md";

// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 20px;
//   max-width: 600px;
//   margin: 0 auto;
// `;

// const Input = styled.input`
//   padding: 10px;
//   margin-bottom: 10px;
//   width: 100%;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   box-sizing: border-box;
// `;

// const Button = styled.button`
//   padding: 10px 20px;
//   background-color: #007bff;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;

//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const ErrorMessage = styled.div`
//   color: red;
//   margin-top: 10px;
// `;

// const DetailsContainer = styled.div`
//   margin-top: 20px;
//   padding: 20px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   width: 100%;
// `;

// const Detail = styled.div`
//   margin-bottom: 10px;
//   font-size: 16px;

//   span {
//     font-weight: bold;
//   }
// `;

// const CardsContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//   gap: 20px;
//   width: 100%;
//   padding: 10px;
// `;


// const IconContainer = styled.div`
//   margin-bottom: 15px;
//   color: #007bff;
// `;

// const Card = styled.div`
//   background-color: #fff;
//   border-radius: 10px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   padding: 20px;
//   text-align: center;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
//   }
// `;

// const CardText = styled.div`
//   h3 {
//     font-size: 1.2rem;
//     color: #333;
//     margin-bottom: 10px;
//   }

//   p {
//     font-size: 1rem;
//     color: #666;
//     font-weight: bold;
//   }
// `;

// const OrdersContainer = styled.div`
//   width: 100%;
//   margin-top: 40px;
// `;

// const OrdersTitle = styled.h2`
//   font-size: 1.5rem;
//   color: rgba(0,0,255,0.5);
//   margin-bottom: 20px;
// `;


// const OrdersList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 15px;
// `;

// const OrderItem = styled.div`
//   padding: 15px;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   background-color: #fff;

//   p {
//     margin: 5px 0;
//     font-size: 0.9rem;

//     strong {
//       font-weight: bold;
//     }
//   }
// `;

// const AffiliateSearchAndDetails = () => {
//   const [referralCode, setReferralCode] = useState("");
//   const [affiliate, setAffiliate] = useState(null);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [orders, setOrders] = useState([]);

  
//   const calculateNextSettlementDate = () => {
//     const today = new Date();
//     const nextDate = new Date(today);
//     nextDate.setMonth(today.getMonth() + 1); // Move to next month
//     return nextDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
//   };


//   const [affiliateData, setAffiliateData] = useState({
//     numberOfSales: 0,
//     totalAffiliateAmount: 0,
//     amountSettled: 0,
//     amountToBeSettled: 0,
//     nextSettlementDate: calculateNextSettlementDate(),
//   });



//   const handleSearch = async () => {
//     if (!referralCode.trim()) {
//       setError("Please enter a referral code.");
//       return;
//     }

//     setError("");
//     setLoading(true);
//     setAffiliate(null);

//     try {
//       const response = await fetch(
//         "https://elexdondigitalacademy.com/api/get_affiliate_by_referral_code.php",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ referralCode }),
//         }
//       );
//       const data = await response.json();

//       if (data.success) {
//         setAffiliate(data.affiliate);
//         fetchOrders();

//       } else {
//         setError(data.error);
//       }
//     } catch (err) {
//       setError("An error occurred while fetching affiliate details.");
//     } finally {
//       setLoading(false);
//     }
//   };

  

//   const fetchOrders = async () => {
//     try {
//       const response = await fetch("https://elexdondigitalacademy.com/api/fetch_orders_by_referrer_code.php", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ referrer_code: referralCode }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch orders.");
//       }

//       const data = await response.json();

//       if (Array.isArray(data)) {
//         setOrders(data);
//         setReferralCode("")
//         calculateAffiliateData(data);
//       } else {
//         setError("No orders found.");
//       }
//     } catch (err) {
//       setError(err.message);  
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateAffiliateData = (orders) => {
//     const totalSales = orders.length;
//     const totalAmount = orders.reduce((sum, order) => sum + (order.total_amount*20/100 || 0), 0);

//     setAffiliateData((prevState) => ({
//       ...prevState,
//       numberOfSales: totalSales,
//       totalAffiliateAmount: totalAmount,
//       amountToBeSettled: totalAmount - prevState.amountSettled, // Adjust as needed
//     }));
//   };

//   return (
//     <Container>
//       <h2 style={{color:"rgba(0,0,255,0.5)"}}>Affiliate Search</h2> 
//       <Input
//         type="text"
//         placeholder="Enter Referral Code"
//         value={referralCode}
//         onChange={(e) => setReferralCode(e.target.value)}
//       />
//       <Button onClick={handleSearch}>Search</Button>
//       {error && <ErrorMessage>{error}</ErrorMessage>}
//       {loading && <p>Loading...</p>}
//       {affiliate && (
//         <DetailsContainer>
//           <Detail>
//             <span>Name:</span> {affiliate.first_name} {affiliate.last_name}
//           </Detail>
//           <Detail>
//             <span>Email:</span> {affiliate.email}
//           </Detail>
//           <Detail>
//             <span>Phone:</span> {affiliate.phone}
//           </Detail>
//           <Detail>
//             <span>Bank Name:</span> {affiliate.bank_name}
//           </Detail>
//           <Detail>
//             <span>Account Number:</span> {affiliate.bank_account_number}
//           </Detail>
//           <Detail>
//             <span>Referral Code:</span> {affiliate.referral_code}
//           </Detail>
//         </DetailsContainer>
//       )}
      
//       {affiliate && <CardsContainer>
//         <Card>
//           <IconContainer>
//             <FaShoppingCart size={30} />
//           </IconContainer>
//           <CardText>
//             <h3>Number of Sales</h3>
//             <p>{affiliateData.numberOfSales}</p>
//           </CardText>
//         </Card>
//         <Card>
//           <IconContainer>
//             <FaMoneyBill size={30} />
//           </IconContainer>
//           <CardText>
//             <h3>Total Affiliate Amount</h3>
//             <p>₦{affiliateData.totalAffiliateAmount}</p>
//           </CardText>
//         </Card>
//         <Card>  
//           <IconContainer>
//             <MdAccountBalanceWallet size={30} />
//           </IconContainer>
//           <CardText>
//             <h3>Amount Settled</h3>
//             <p>₦{affiliateData.amountSettled}</p>
//           </CardText>
//         </Card>
//         <Card>
//           <IconContainer>
//             <MdAccountBalanceWallet size={30} />
//           </IconContainer>
//           <CardText>
//             <h3>Amount to be Settled</h3>
//             <p>₦{affiliateData.amountToBeSettled}</p>
//           </CardText>
//         </Card>
//         <Card>
//           <IconContainer>
//             <FaRegCalendarAlt size={30} />
//           </IconContainer>
//           <CardText>
//             <h3>Next Settlement Date</h3>
//             <p>{affiliateData.nextSettlementDate}</p>
//           </CardText>
//         </Card>
//       </CardsContainer>}


//       {affiliate && <OrdersContainer>
//         <OrdersTitle>Sales</OrdersTitle>
//         {loading ? (
//           <p>Loading sales...</p>
//         ) : error ? (
//           <p style={{ color: "red" }}>{error}</p>
//         ) : orders.length > 0 ? (
//           <OrdersList>
//             {orders.map((order) => (
//               <OrderItem key={order.id}>
//                 <p>
//                   <strong>Date:</strong> {order.order_date}
//                 </p>
//                 <p>
//                   <strong>Transaction Ref:</strong> {order.transaction_reference}
//                 </p>
//                 <p>
//                   <strong>Name:</strong> {order.name}
//                 </p>
//                 <p>
//                   <strong>Email:</strong> {order.email}
//                 </p>
//                 <p>
//                   <strong>Total Amount:</strong> ₦{order.total_amount}
//                 </p>
//               </OrderItem>
//             ))}
//           </OrdersList>
//         ) : (
//           <p>No sales found.</p>
//         )}
//       </OrdersContainer>}
//     </Container>
//   );
// };

// export default AffiliateSearchAndDetails;










// src/components/AffiliateSearchAndDetails.jsx
import React, { useState } from "react";
import styled from "styled-components";
import { FaMoneyBill, FaRegCalendarAlt, FaShoppingCart, FaSearch, FaUserAlt, FaEnvelope, FaPhone, FaUniversity, FaCreditCard, FaTicketAlt } from "react-icons/fa";
import { MdAccountBalanceWallet } from "react-icons/md";

const AffiliateSearchAndDetails = () => {
  const [referralCode, setReferralCode] = useState("");
  const [affiliate, setAffiliate] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);

  const calculateNextSettlementDate = () => {
    const today = new Date();
    const nextDate = new Date(today);
    nextDate.setMonth(today.getMonth() + 1);
    return nextDate.toISOString().split("T")[0];
  };

  const [affiliateData, setAffiliateData] = useState({
    numberOfSales: 0,
    totalAffiliateAmount: 0,
    amountSettled: 0,
    amountToBeSettled: 0,
    nextSettlementDate: calculateNextSettlementDate(),
  });

  const handleSearch = async () => {
    if (!referralCode.trim()) {
      setError("Please enter a referral code.");
      return;
    }

    setError("");
    setLoading(true);
    setAffiliate(null);

    try {
      const response = await fetch(
        "https://elexdondigitalacademy.com/api/get_affiliate_by_referral_code.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ referralCode }),
        }
      );
      const data = await response.json();

      if (data.success) {
        setAffiliate(data.affiliate);
        fetchOrders();
      } else {
        setError(data.error);
        setLoading(false);
      }
    } catch (err) {
      setError("An error occurred while fetching affiliate details.");
      setLoading(false);
    }
  };

  const fetchOrders = async () => {
    try {
      const response = await fetch("https://elexdondigitalacademy.com/api/fetch_orders_by_referrer_code.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ referrer_code: referralCode }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch orders.");
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        setOrders(data);
        calculateAffiliateData(data);
      } else {
        setOrders([]);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const calculateAffiliateData = (orderItems) => {
    const totalSales = orderItems.length;
    const totalAmount = orderItems.reduce((sum, order) => sum + ((order.total_amount * 20) / 100 || 0), 0);

    setAffiliateData((prevState) => ({
      ...prevState,
      numberOfSales: totalSales,
      totalAffiliateAmount: totalAmount,
      amountToBeSettled: totalAmount - prevState.amountSettled,
    }));
  };

  return (
    <PageContainer>
      <PageHeader>
        <h2>Affiliate Management</h2>
        <p>Search and review affiliate performance, profile data, and commission history.</p>
      </PageHeader>

      <SearchCard>
        <SearchWrapper>
          <InputWrapper>
            <FaSearch color="#64748b" />
            <Input
              type="text"
              placeholder="Enter Referral Code (e.g., REF123)"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
          </InputWrapper>
          <Button onClick={handleSearch} disabled={loading}>
            {loading ? "Searching..." : "Search Affiliate"}
          </Button>
        </SearchWrapper>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </SearchCard>

      {loading && <LoadingText>Fetching affiliate profile...</LoadingText>}

      {affiliate && (
        <>
          <DetailsContainer>
            <SectionTitle>Affiliate Profile Information</SectionTitle>
            <DetailsGrid>
              <DetailItem>
                <FaUserAlt color="#2563eb" />
                <div>
                  <Label>Full Name</Label>
                  <Value>{affiliate.first_name} {affiliate.last_name}</Value>
                </div>
              </DetailItem>
              <DetailItem>
                <FaEnvelope color="#2563eb" />
                <div>
                  <Label>Email Address</Label>
                  <Value>{affiliate.email}</Value>
                </div>
              </DetailItem>
              <DetailItem>
                <FaPhone color="#2563eb" />
                <div>
                  <Label>Phone Number</Label>
                  <Value>{affiliate.phone || 'Not provided'}</Value>
                </div>
              </DetailItem>
              <DetailItem>
                <FaUniversity color="#2563eb" />
                <div>
                  <Label>Bank Name</Label>
                  <Value>{affiliate.bank_name || 'Not provided'}</Value>
                </div>
              </DetailItem>
              <DetailItem>
                <FaCreditCard color="#2563eb" />
                <div>
                  <Label>Account Number</Label>
                  <Value>{affiliate.bank_account_number || 'Not provided'}</Value>
                </div>
              </DetailItem>
              <DetailItem>
                <FaTicketAlt color="#2563eb" />
                <div>
                  <Label>Referral Code</Label>
                  <BadgeValue>{affiliate.referral_code}</BadgeValue>
                </div>
              </DetailItem>
            </DetailsGrid>
          </DetailsContainer>

          <CardsContainer>
            <Card>
              <IconContainer><FaShoppingCart size={24} /></IconContainer>
              <CardText>
                <h3>Number of Sales</h3>
                <p>{affiliateData.numberOfSales}</p>
              </CardText>
            </Card>
            <Card>
              <IconContainer><FaMoneyBill size={24} /></IconContainer>
              <CardText>
                <h3>Total Earnings (20%)</h3>
                <p>₦{affiliateData.totalAffiliateAmount.toLocaleString()}</p>
              </CardText>
            </Card>
            <Card>
              <IconContainer><MdAccountBalanceWallet size={24} /></IconContainer>
              <CardText>
                <h3>Amount Settled</h3>
                <p>₦{affiliateData.amountSettled.toLocaleString()}</p>
              </CardText>
            </Card>
            <Card>
              <IconContainer><MdAccountBalanceWallet size={24} /></IconContainer>
              <CardText>
                <h3>Amount Pending</h3>
                <p>₦{affiliateData.amountToBeSettled.toLocaleString()}</p>
              </CardText>
            </Card>
            <Card>
              <IconContainer><FaRegCalendarAlt size={24} /></IconContainer>
              <CardText>
                <h3>Next Settlement</h3>
                <p style={{ fontSize: '0.95rem' }}>{affiliateData.nextSettlementDate}</p>
              </CardText>
            </Card>
          </CardsContainer>

          <OrdersContainer>
            <OrdersTitle>Referred Sales History</OrdersTitle>
            {orders.length > 0 ? (
              <OrdersList>
                {orders.map((order) => (
                  <OrderItem key={order.id}>
                    <OrderInfoRow>
                      <span><strong>Ref:</strong> {order.transaction_reference}</span>
                      <DateBadge>{order.order_date}</DateBadge>
                    </OrderInfoRow>
                    <OrderDetailsGrid>
                      <p><strong>Customer:</strong> {order.name}</p>
                      <p><strong>Email:</strong> {order.email}</p>
                      <p><strong>Order Total:</strong> ₦{Number(order.total_amount).toLocaleString()}</p>
                    </OrderDetailsGrid>
                  </OrderItem>
                ))}
              </OrdersList>
            ) : (
              <EmptyOrdersCard>No sales recorded under this referral code yet.</EmptyOrdersCard>
            )}
          </OrdersContainer>
        </>
      )}
    </PageContainer>
  );
};

export default AffiliateSearchAndDetails;

// --- Styled Components ---
const PageContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  font-family: inherit;
`;

const PageHeader = styled.div`
  margin-bottom: 24px;

  h2 {
    color: #0f172a;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 4px 0;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const SearchCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  margin-bottom: 24px;
`;

const SearchWrapper = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  padding: 0 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background-color: #f8fafc;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: #2563eb;
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 0;
  border: none;
  background: transparent;
  font-size: 0.95rem;
  outline: none;
  color: #1e293b;
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #1d4ed8;
  }

  &:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #dc2626;
  margin-top: 12px;
  font-size: 0.9rem;
  font-weight: 500;
`;

const LoadingText = styled.p`
  text-align: center;
  color: #64748b;
  padding: 20px;
`;

const DetailsContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  margin-bottom: 24px;
`;

const SectionTitle = styled.h3`
  font-size: 1.1rem;
  color: #0f172a;
  margin: 0 0 20px 0;
  font-weight: 600;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 10px;
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
`;

const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
`;

const Label = styled.span`
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  font-weight: 600;
`;

const Value = styled.span`
  font-size: 0.95rem;
  color: #1e293b;
  font-weight: 500;
`;

const BadgeValue = styled.span`
  display: inline-block;
  background: #e0f2fe;
  color: #0369a1;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: monospace;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
`;

const Card = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  }
`;

const IconContainer = styled.div`
  padding: 10px;
  background: #eff6ff;
  border-radius: 8px;
  margin-bottom: 12px;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardText = styled.div`
  h3 {
    font-size: 0.85rem;
    color: #64748b;
    margin: 0 0 4px 0;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  p {
    font-size: 1.25rem;
    color: #0f172a;
    font-weight: 700;
    margin: 0;
  }
`;

const OrdersContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
`;

const OrdersTitle = styled.h3`
  font-size: 1.1rem;
  color: #0f172a;
  margin: 0 0 16px 0;
  font-weight: 600;
`;

const OrdersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const OrderItem = styled.div`
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8fafc;
`;

const OrderInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 0.9rem;
  color: #334155;
`;

const DateBadge = styled.span`
  background: #f1f5f9;
  color: #475569;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
`;

const OrderDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
  font-size: 0.9rem;
  color: #64748b;

  p {
    margin: 0;
    strong {
      color: #1e293b;
    }
  }
`;

const EmptyOrdersCard = styled.div`
  padding: 32px;
  text-align: center;
  color: #64748b;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  font-size: 0.95rem;
`;